import {
  B2bCompanyPaymentMethod,
  PaymentMethodIntent,
  PaymentMethodType,
} from '@Common/types/bo/b2b/companies';

function hasActive(
  paymentMethods: B2bCompanyPaymentMethod[],
  type: PaymentMethodType,
  intent: PaymentMethodIntent,
) {
  return paymentMethods.some(
    (paymentMethod) => paymentMethod.type === type && paymentMethod.intent === intent,
  );
}

export function isSepaDirectDebitDisabled(
  paymentMethods: B2bCompanyPaymentMethod[] = [],
  intent: PaymentMethodIntent = 'principal',
) {
  return hasActive(paymentMethods, 'sepa_direct_debit', intent);
}

export function isExternalBankDisabled(
  paymentMethods: B2bCompanyPaymentMethod[] = [],
  intent: PaymentMethodIntent = 'principal',
) {
  return hasActive(paymentMethods, 'external_bank', intent);
}

/**
 * Two payment methods can point to the same mandate / beneficiary (same IBAN).
 * Deleting one of them only deletes that payment method, the shared mandate / beneficiary stays
 * active for the other ones.
 */
export function sharesAccountWithAnotherPaymentMethod(
  paymentMethod: B2bCompanyPaymentMethod,
  paymentMethods: B2bCompanyPaymentMethod[],
) {
  return paymentMethods.some(
    (other) =>
      other.id !== paymentMethod.id &&
      ((paymentMethod.co_sepa_mandate_id !== null &&
        paymentMethod.co_sepa_mandate_id === other.co_sepa_mandate_id) ||
        (paymentMethod.mdlr_beneficiary_id !== null &&
          paymentMethod.mdlr_beneficiary_id === other.mdlr_beneficiary_id)),
  );
}
